import { ProfileBenefitSearchParams } from '../shared/profile-benefit-search-params.model';
import { MembershipLevelBenefitSearchResult } from '../shared/membership-level-benefit-search-result.model';

export class BenefitMgtComponentModel {
  public selectAllProfiles: boolean;
  public selectedProfiles: Array<number>;
  public showAdvancedSearch: boolean;
  public benefits: MembershipLevelBenefitSearchResult;
  public searchParams: ProfileBenefitSearchParams;
  public userNum: string;
  public clientId: string;

  public constructor() {
    this.benefits = new MembershipLevelBenefitSearchResult();
    this.searchParams = new ProfileBenefitSearchParams();
    this.selectedProfiles = new Array<number>();
    this.selectAllProfiles = false;
    this.showAdvancedSearch = false;
    this.clientId = '';
    this.userNum = '';
  }
}
